import React from "react";
import { resolveMediaUrl } from "@/components/FileUpload";
import { NEUTRAL_POSTER } from "@/lib/neutralPoster";

// Libellé court d'un message cité (réponse) : texte, sinon type de média traduit.
export const quoteLabel = (r, t) => {
  if (r?.content) return r.content;
  const tr = (k, d) => (t ? t(k, d) : d);
  if (r?.media_type === "video") return tr("chat.media_video", "🎥 Vidéo");
  if (r?.media_type === "audio") return tr("chat.media_audio", "🎤 Message vocal");
  if (r?.media_type === "album") return tr("chat.media_album", "📷 Album");
  return tr("chat.media_photo", "📷 Photo");
};

// Thumbnail for a quoted message's media: photo → <img>, video → first-frame preview + ▶ overlay.
export const QuoteThumb = ({ mediaType, url, size = 32, testId }) => {
  if (!url || mediaType === "audio") return null;
  const src = resolveMediaUrl(url);
  const style = { height: size, width: size };
  if (mediaType === "video") {
    return (
      <span className="relative shrink-0 rounded overflow-hidden" style={style} data-testid={testId}>
        <video src={`${src}#t=0.1`} poster={NEUTRAL_POSTER} muted playsInline preload="metadata" className="h-full w-full object-cover bg-black" />
        <span className="absolute inset-0 grid place-items-center text-white text-[9px]">▶</span>
      </span>
    );
  }
  return <img src={src} alt="" className="rounded object-cover shrink-0" style={style} data-testid={testId} />;
};
